import {
	Paper,
	Typography,
	List,
	ListItem,
	ListItemText,
	IconButton,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const EmailRuleSection = ({
	title,
	type,
	items,
	handleDelete,
	disabled,
	tenantLevel,
}) => {
	const lowerCased = title.toLowerCase();

	return (
		<Paper variant='outlined' sx={{ p: 2 }}>
			<Typography variant='subtitle2' gutterBottom>
				{title}
			</Typography>
			{items.length === 0 ? (
				<Typography variant='body2' color='text.secondary'>
					No {lowerCased}
				</Typography>
			) : (
				<List dense>
					{items.map((item, index) => (
						<ListItem
							key={index}
							secondaryAction={
								tenantLevel || item.user_id ? (
									<IconButton
										edge='end'
										aria-label='delete'
										onClick={() => handleDelete(type, item.id)}
										size='small'
										disabled={disabled}
									>
										<DeleteIcon />
									</IconButton>
								) : (
									<span>Tenant Rule</span>
								)
							}
						>
							<ListItemText primary={item.value} />
						</ListItem>
					))}
				</List>
			)}
		</Paper>
	);
};
export default EmailRuleSection;
